import React, { Fragment, useState, useEffect,useRef } from "react";
import { Button, Form, FormGroup, Label, Input,Col } from "reactstrap";
import Select from "react-select";
import MenuItem from "react-select";
import { render } from "@testing-library/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../style/calendarclass.css";
import Multiselect from 'multiselect-react-dropdown';
import "../../style/numbertextstyle.css";
const FormFieldsAttribute = React.memo((props) => {
  const { inputFields, formValidation,selectedDesig,formvaltype,handelonRemove,handelonchangeevent } = props;
  const [inputFieldsArr, setInputFieldsArr] = useState(null);
const[desoptions , setOptions] =useState([{}]);
const[selected,setselected]=useState([]);


let options=[];
let optionsprop=[];
let optionselect=[];
let optionselectcom=[];
let optionselectdep=[];
   inputFields.map(function (desig) {
    if(desig.type=="multipleselect" && desig.option.length >0)
    {
      // options.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        options.push({value: el.designationId, label: el.designationName }); 
      })
     
    }
    if(desig.type=="mutliselectprop" && desig.option.length >0)
    {
      optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionsprop.push({value: el.designationId, label: el.designationName }); 
      })
     
    }
    if(desig.type=="selectn" && desig.option.length >0)
    {
      desig.option.map((el,i) =>{
        optionselect.push({
          value :el.ItemCategoryId,label:el.ItemCategoryName
        })
      })
    }
    if(desig.type=="select" && desig.option.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionselect.push({
          value:desig.name=="itemCategory" ? (el.ItemCategoryId) : 
          ((desig.name =="departmentId" ? (el.departmentId):
          ((desig.name == "officeLocationId") ? (el.officeLocationId) : 
          ((desig.name == "skillCategoryId" ? (el.skillCategoryId) : (null)))))),

          label:desig.name=="itemCategory" ? (el.ItemCategoryName) : 
          (desig.name=="departmentId" ? (el.departmentName) : 
          ((desig.name == "officeLocationId") ? (el.address) : 
          ((desig.name == "skillCategoryId" ? (el.skillCategoryName) : (null)))))
          // value: (el.officeLocationId !== undefined ? el.officeLocationId :
          //        (el.skillCategoryId !== undefined ?(el.skillCategoryId) :(el.calendarYearTypeId))),
          //  label: (el.address !== undefined ? el.address :
          //   (el.skillCategoryName !== undefined ? (el.skillCategoryName) : (el.calendarYearType))) }); 
      })
    })
    }
    if(desig.type=="selectcom" && desig.option.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionselectcom.push({
          value:el.officeLocationId,label:el.departmentName})
    })
    }
    if(desig.type=="selectdep" && desig.option.length >0)
    {
      // optionsprop.push({value:0,label:"Select..."})
      desig.option.map((el,i) =>{
        optionselectdep.push({
          value:el.officeLocationId,label:el.address})
    })
    }
  })

 const handleSelectChange = (value) =>{
    if(value!==null){
      if(value.length === 1){
        setselected({option: value})
      }else{
        this.setState({option: options}) //here options is original options
      }
    }else{
      this.setState({option: options})
    }
}
const onRemove=(selectedList, removedItem) => {
  handelonchangeevent(selectedList,removedItem,1);
}
// const options = [
//   { value: "Spring", label: "Spring" },
//   { value: "Summer", label: "Summer" },
//   { value: "Autumn", label: "Autumn" },
//   { value: "Winter", label: "Winter" }
// ];

  return (
    <Form>

      {inputFields !== undefined
        ? inputFields.map((val, i) => {
              return (
              <FormGroup key={i} >
                <Label sm={3}>{val.label}</Label>
                {/* if input field is a text or number then */}
                {val.type === "text"? (
                   
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.value);
                    }}   
                    value={props.formval}  
                  />
              ) : null}
              {val.type === "textdes"? (
                   
                   <Input
                     type="text"
                     placeholder={val.placeholder}
                     onChange={(e) => {
                       val.handleOnChange(e.target.value);
                     }}   
                     value={props.formvaldes}  
                   />
               ) : null}
              {val.type === "text1"? (
                   
                   <Input
                     type={val.type}
                     placeholder={val.placeholder}
                     onChange={(e) => {
                       val.handleOnChange(e.target.value);
                     }}   
                     value={props.formval1}  
                   />
               ) : null}
                {val.type === "number" ? (
                 
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnNumberChange(e.target.value);
                    }} value={props.formvalnum}  
                  />
                ) : null}
                {inputFieldsArr}
                {val.type === "file" ? (
                  
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e);
                    }}
                    // value={props.formData ? props.formData.val[val.name] : null}
                  /> 
                ) : null}
                { val.type === "select" ? (
                 
                  <Fragment>
                   
                  
                     <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={optionselect[0]}
        onChange={(e) => {
          val.handleOnChange(e.value,e);
        }} 
        isSearchable={true}
        value={props.formvalue}
        name="color"
        options={optionselect}
      />
                  </Fragment>
                ) : null}
                { val.type === "selectdep" ? (
                 
                 <Fragment>
                  
                 
                    <Select
       className="basic-single"
       classNamePrefix="select"
       defaultValue={optionselectdep[0]}
       onChange={(e) => {
         val.handleOnChange(e.value,e);
       }} 
       isSearchable={true}
       value={props.formvaltype}
       name="color"
       options={optionselectdep}
     />
                 </Fragment>
               ) : null}
                { val.type === "selectcom" ? (
                 
                 <Fragment>
                 
                    <Select
       className="basic-single"
       classNamePrefix="select"
       defaultValue={optionselectcom[0]}
       onChange={(e) => {
         val.handleOnChange(e.value,e.label);
       }} 
       isSearchable={true}
       value={props.formvalue}
       name="color"
       options={optionselectcom}
     />
                 </Fragment>
               ) : null}
                { val.type === "selectn" ? (
                 
                 <Fragment>
                  
                    <Select
       className="basic-single"
       classNamePrefix="select"
       defaultValue={optionselect[0]}
       onChange={(e) => {
         val.handleOnChange(e.value,e);
       }} 
       isSearchable={true}
       value={props.formvalue} 
       name="color"
       options={optionselect}
     />
                 </Fragment>
               ) : null}
                {/* selecttype */}

                {/* if input field is a text or number then */}
                {val.type === "DateFrom"? (
                 
                     
                <DatePicker
                selected={props.formval}
                // value={props.formval}
                onChange={(e) => {
                val.handleOnChange(e);
                }}   

           />
              ) : null}
             {val.type === "DateTo"? (
                 
                <DatePicker
                selected={props.toval}
                // value={props.formval}
                onChange={(e) => {
                val.handleOnChange(e);
                }}   

           />
            ) : null}
             {val.type === "checkbox"? (
                   
                  <Input
                    type={val.type}
                    placeholder={val.placeholder}
                    onChange={(e) => {
                      val.handleOnChange(e.target.value);
                    }}   
                    value={props.formval}  
                  />
               ) : null}
               {val.type === "checkboxCal"? (
                   
                   <Input
                   className="calendaryearcheckbox"
                 
                  // style="margin-left: -126px !important;margin-top: 13px;"
                     type="checkbox"
                     placeholder={val.placeholder}
                     onChange={(e) => {
                       val.handleOnChange(e.target.value);
                     }}   
                     value={props.formval}  
                   />
                ) : null}

                { val.type === "multipleselect" && val.option.length >0 ? (
                 
                 <Fragment>
<Multiselect
options={options}
selectedValues={selectedDesig} 
onSelect={(e) => {
 
    val.handleOnChange(e[e.length-1],e,0);
 
}} 
onRemove={onRemove}
displayValue="label"
/>
          {/* <Select style={{color:"black"}} isClearable={true}
        isMulti  
        name="Multisel"
        options={options} 
        // value={ selectedDesig.length > 0? selectedDesig :null}
        defaultValue={selectedDesig}
        
        onRemove={onRemove}
        onChange={(e) => {
          val.handleOnChange(e[e.length-1].value,e);
        }}
        // onChange={this.handleSelectChange}
        >
         
          </Select> */}
                 </Fragment>
               ) : null}
               
                {Object.keys(formValidation)?.length !== 0 &&
                  !formValidation?.[val.name]?.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation?.[val.name]?.errorMessage}
                    </span>
                  )}
              </FormGroup>
            );
          })
        : null}
      <Button
        color=""
        className="btn-admin-settings"
        onClick={props.handleSubmit}
      >
        {props.button}
      </Button>{" "}
      &nbsp;
      <Button color="" className="btn-cancel" onClick={props.toggle}>
        Cancel
      </Button>
    </Form>
  );
});

export default FormFieldsAttribute;
